import { useActivityTracker } from '@/hooks/useActivityTracker';

/** Invisible component that initialises activity tracking */
export const ActivityTrackerInit = () => {
  useActivityTracker();
  return null;
};
